export function getRandomGroupedArray(array, index) {
    // 从索引位置开始，截取数组并将其连接
    const firstPart = array.slice(index + 1); // 从 index 后面的部分
    const secondPart = array.slice(0, index + 1); // 从开始到 index 包括它

    // 返回首尾相连的新数组
    return [...firstPart, ...secondPart];
}
